import { trackDownload } from "@/lib/api";

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  const bar = document.querySelector("[data-topbar]")?.offsetHeight ?? 110;
  const offset = -(bar + 16);
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset, duration: 1.3 });
  } else {
    window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY + offset });
  }
  if (!el.hasAttribute("tabindex")) el.setAttribute("tabindex", "-1");
  el.focus({ preventScroll: true });
  window.history.replaceState(null, "", `#${id}`);
};

export const printTools = (id) => {
  if (id === "page") {
    document.body.classList.add("printing");
    const off = () => { document.body.classList.remove("printing"); window.removeEventListener("afterprint", off); };
    window.addEventListener("afterprint", off);
    window.print();
    return;
  }
  const targets = id ? [document.getElementById(id)] : [...document.querySelectorAll(".tool-section")];
  targets.forEach((t) => t?.classList.add("print-target"));
  document.body.classList.add("printing");
  if (!id) document.body.classList.add("printing-all");
  const qs = targets[0]?.closest?.("#qs-pack");
  if (qs) document.body.classList.add("printing-qs");
  const pack = targets[0]?.closest?.("[data-pack]")?.dataset.pack;
  if (id !== "ws-report") trackDownload(id === "poster" ? "poster-pdf" : id ? `section-${id}` : pack || (qs ? "quick-start-pack" : "resource-pack"));
  const done = () => {
    targets.forEach((t) => t?.classList.remove("print-target"));
    document.body.classList.remove("printing", "printing-all", "printing-qs");
    window.removeEventListener("afterprint", done);
    setTimeout(() => window.dispatchEvent(new CustomEvent("sap:exported")), 400);
  };
  window.addEventListener("afterprint", done);
  window.print();
};
